import Vue from 'vue'
import App from './App.vue'

import '././assets/css/public.css';
import router from '././plugins/router.config';


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
